import { IconButton } from "../../../controls/TooltipControls";
import { ComponentEx } from "../../../controls/ComponentEx";
import { getSafe } from "../../../util/storeHelper";
import { truthy } from "../../../util/util";
import * as React from "react";
import { ControlLabel, FormGroup, OverlayTrigger, Popover, } from "react-bootstrap";
import Interweave, { Filter } from "interweave";
class LinkFilter extends Filter {
    attribute(name, value) {
        if (["href", "src"].includes(name)) {
            return undefined;
        }
        return value;
    }
    node(name, node) {
        if (name === "a") {
            for (let i = 0; i < node.attributes.length; ++i) {
                node.removeAttributeNode(node.attributes[i]);
            }
        }
        return node;
    }
}
/**
 * VersionChangelog Button
 *
 * @class VersionChangelogButton
 */
class VersionChangelogButton extends ComponentEx {
    render() {
        const { mod, t } = this.props;
        const changelog = getSafe(mod.attributes, ["changelog"], undefined);
        const newestChangelog = getSafe(mod.attributes, ["newestChangelog"], undefined);
        if (!truthy(changelog) && !truthy(newestChangelog)) {
            return null;
        }
        const popoverBottom = (React.createElement(Popover, { id: "popover-changelog", title: t("Changelogs") },
            React.createElement("div", { style: { maxHeight: 500, overflowY: "auto" } },
                React.createElement(FormGroup, null,
                    React.createElement(ControlLabel, null, t("Current Version")),
                    React.createElement("div", { key: "dialog-form-changelog", className: "mod-changelog" }, this.renderChangelog(changelog))),
                React.createElement(FormGroup, null,
                    React.createElement(ControlLabel, null, t("Newest Version")),
                    React.createElement("div", { key: "dialog-form-newestChangelog", className: "mod-changelog" }, this.renderChangelog(newestChangelog))))));
        return (React.createElement(OverlayTrigger, { trigger: "click", rootClose: true, placement: "right", overlay: popoverBottom },
            React.createElement(IconButton, { className: "btn-embed", icon: "changelog", id: `btn-changelog-${mod.id}`, tooltip: t("Changelog") })));
    }
    renderChangelog(changelog) {
        const { t } = this.props;
        if (changelog === undefined) {
            return null;
        }
        if (changelog.format === "html") {
            try {
                return (React.createElement(Interweave, { content: changelog.content, filters: [new LinkFilter()] }));
            }
            catch (err) {
                // probably caused by an odd, very very rare bug loading included modules
                return React.createElement("p", null, t("Parsing the changelog failed"));
            }
        }
        else {
            return React.createElement("p", null, changelog.content);
        }
    }
}
export default VersionChangelogButton;
